// ============================================================================
// Helpers
// ============================================================================
// Waits for quick filter pills to exist in the DOM, then invokes callback (with optional retries)
function waitForQuickFilters(callback, retries = 10) {
  const quickFiltersExist = document.querySelector(
    ".quick-filter-main .custom-button.selected a",
  )
  if (quickFiltersExist) {
    callback()
  } else if (retries > 0) {
    setTimeout(() => waitForQuickFilters(callback, retries - 1), 100)
  } else {
    callback()
  }
}

// Gets the stored quick filter pill order array from localStorage
function getPillOrderArr() {
  try {
    return JSON.parse(localStorage.getItem("quickFilterOrderArr") || "[]")
  } catch {
    return []
  }
}
// Stores the quick filter pill order array to localStorage
function setPillOrderArr(arr) {
  localStorage.setItem("quickFilterOrderArr", JSON.stringify(arr))
}
let quickFilterPillOrder = 0
// Track clearing state for all filters to prevent multiple triggers
let isClearingAllFilters = false
let wasQuickFilterPillClick = false
let shouldRestoreScroll = true
// Updates the product count display in #ProductCount or #ProductCountDesktop
function updateProductCountDisplay() {
  const updatedGrid = document.querySelector("#ProductGridContainer")
  const visibleCount = updatedGrid?.querySelectorAll(".grid__item").length || 0

  const totalElem = document.querySelector("#CollectionTrueTotal")
  let totalCount = 0
  if (totalElem && totalElem.getAttribute("data-collection-total")) {
    totalCount = parseInt(
      totalElem.getAttribute("data-collection-total") || "0",
      10,
    )
  } else {
    // fallback
    const dynamicTotalElem = document.querySelector(".custom-total-product")
    totalCount =
      parseInt(dynamicTotalElem?.textContent.replace(/,/g, "") || "0", 10) ||
      visibleCount
  }

  const countElem = document.querySelector(
    "#ProductCount, #ProductCountDesktop",
  )
  if (countElem && totalElem) {
    let text = ""
    // Support both Shopify-style and custom placeholder replacement
    const filteredT =
      totalElem.getAttribute("data-product-count") ||
      "{{ product_count }} of {{ count }} products"
    const simpleOne =
      totalElem.getAttribute("data-product-count-one") || "{{ count }} product"
    const simpleOther =
      totalElem.getAttribute("data-product-count-other") ||
      "{{ count }} products"

    if (visibleCount === totalCount || visibleCount === 0) {
      // Only total, no filtering or all shown
      text = (totalCount === 1 ? simpleOne : simpleOther)
        .replace("{{ count }}", totalCount)
        .replace("[COUNT]", totalCount)
    } else {
      // Filtered view: use pluralization and support both Shopify and custom placeholders
      let filteredText = filteredT
      text = filteredText
        .replace("{{ product_count }}", visibleCount)
        .replace("[VISIBLE]", visibleCount)
        .replace("{{ count }}", totalCount)
        .replace("[TOTAL]", totalCount)
    }
    countElem.textContent = text
  }
}
// Resets all filters and reloads the page content and filters, preserving q and options[prefix]
function resetAllFiltersAndReload() {
  wasDrawerOpen = false
  if (isClearingAllFilters) return
  isClearingAllFilters = true
  // Always preserve q and options[prefix] from CURRENT URL
  const url = new URL(window.location.href)
  const params = url.searchParams

  const preservedParams = {}
  if (params.has("q")) preservedParams["q"] = params.get("q")
  if (params.has("options[prefix]"))
    preservedParams["options[prefix]"] = params.get("options[prefix]")

  // AJAX reload with only preserved params
  shouldRestoreScroll = false
  wasQuickFilterPillClick = false
  updateURL(preservedParams)

  // --- PATCH: Reset sort radios and custom sort UI after clearing filters ---
  setTimeout(() => {
    // 1. Drawer sort radios (with .mobile-facets__label active)
    document.querySelectorAll('input[name="sort_by"]').forEach((radio) => {
      radio.checked = false
      const label = radio.closest(".mobile-facets__label")
      if (label) label.classList.remove("active")
    })

    // 2. Custom sort radios (dropdown UI with .custom-search-sort active)
    // document
    //   .querySelectorAll('.multiple-custom-sort-options input[name="sort_by"]')
    //   .forEach((radio) => {
    //     const isFeatured = radio.value === "manual"
    //     radio.checked = isFeatured
    //     const wrapper = radio.closest(".custom-search-sort")
    //     if (wrapper) {
    //       if (isFeatured) wrapper.classList.add("active")
    //       else wrapper.classList.remove("active")
    //     }
    //   })

    // 3. Update the custom sort label ("Featured")
    const selectedSortCustomDiv = document.querySelector(
      ".selected-sort-custom",
    )
    if (selectedSortCustomDiv)
      selectedSortCustomDiv.textContent =
        window.mostRelevantLabel || "Most relevant"
  }, 200)

  // Clear pills from localStorage and UI
  setPillOrderArr([])
  userSelectedSort = false
  userManuallySorted = false
  // if (window.renderQuick) window.renderQuick({})
  toggleClearFiltersVisibility()

  // Wait for AJAX reload, then update sort label active state and fallback to "Featured"
  setTimeout(() => {
    // Mark the current sort label as active
    const sortRadio = document.querySelector('input[name="sort_by"]:checked')
    // document.querySelectorAll(".mobile-facets__label").forEach((label) => {
    //   const radio = label.querySelector('input[name="sort_by"]')
    //   if (radio && sortRadio && radio.value === sortRadio.value) {
    //     label.classList.add("active")
    //   } else {
    //     label.classList.remove("active")
    //   }
    // })
  }, 200)

  setTimeout(() => {
    isClearingAllFilters = false
  }, 200)
  // Update product count display after all timeouts (after reload)
  setTimeout(updateProductCountDisplay, 200)
  setPillOrderArr([])
  userSelectedSort = false
  userManuallySorted = false
  filterSelectionTag.track()
  return
}
window.skipScrollBecauseOfQuickFilterClick = false
document.addEventListener("mousedown", function (event) {
  const isQuickFilter = event.target.closest(".quick-filter-pill")
  window.skipScrollBecauseOfQuickFilterClick = !!isQuickFilter
})
// Scrolls the quick filter container to the left, unless a pill click prevents it
function tryScrollLeft() {
  if (window.skipScrollBecauseOfQuickFilterClick) {
    window.skipScrollBecauseOfQuickFilterClick = false
    return
  }
  if (window.quickFilterClickPreventScroll) {
    return
  }
  const pillContainer = document.querySelector(".quick-filter-main")
  if (pillContainer) {
    pillContainer.scrollTo({ left: 0, behavior: "smooth" })
  }
}
// Gets the legacy quick filter pill order from localStorage
function getPillOrder() {
  return JSON.parse(localStorage.getItem("quickFilterOrder") || "[]")
}
// Sets the legacy quick filter pill order in localStorage
function setPillOrder(order) {
  localStorage.setItem("quickFilterOrder", JSON.stringify(order))
}
// Builds a unique key for a filter pill
function getPillKey(key, value) {
  return key + "-" + value
}
// Creates a DOM element from an HTML string
function createElementFromHTML(htmlString) {
  const div = document.createElement("div")
  div.innerHTML = htmlString.trim()
  return div.firstChild
}
// Normalizes a filter value for comparison (strips special chars, lowercases, trims)
function normalizeFilterValue(val) {
  if (typeof val !== "string") return ""
  return val
    .replace(/\+/g, " ")
    .replace(/%20/g, " ")
    .replace(/[^a-zA-Z0-9 ]+/g, "")
    .toLowerCase()
    .trim()
}
// Checks if the given filter value matches any quick filter pill in the DOM
function isQuickFilterMatch(filterValue) {
  const normalized = filterValue.trim().toLowerCase()
  const quickFilterSpans = document.querySelectorAll(".quick-filter-pill")
  for (const span of quickFilterSpans) {
    const label = span.textContent.trim().toLowerCase()
    const dataVal = span
      .getAttribute("data-p")
      ?.split("|")[1]
      ?.trim()
      .toLowerCase()
    if (normalized === label || normalized === dataVal) {
      return true
    }
  }
  return false
}
// Creates and appends a quick filter pill to the container, if not already present
function createQuickFilterPill(
  type,
  value,
  label,
  isMostPopular = false,
  isQuickFilter = false,
  isQuickFilterMatch = true,
) {
  if (isMostPopular) return
  const container = document.querySelector(".quick-filters-container")
  if (!container) return
  const existing = container.querySelector(`[data-${type}="${value}"]`)
  if (existing) return
  const pillElement = document.createElement("span")
  pillElement.className = "quick-filter-pill"
  pillElement.setAttribute(`data-${type}`, value)
  pillElement.textContent = label
  if (!pillElement || !(pillElement instanceof Node) || !container) return
  if (pillElement && container) {
    container.appendChild(pillElement)
  }
}

function updateActiveSortLabel() {
  const sortRadio = document.querySelector('input[name="sort_by"]:checked')
  // document.querySelectorAll(".mobile-facets__label").forEach((label) => {
  //   const radio = label.querySelector('input[name="sort_by"]')
  //   if (radio && sortRadio && radio.value === sortRadio.value) {
  //     label.classList.add("active")
  //   } else {
  //     label.classList.remove("active")
  //   }
  // })
}

function updateDrawerSortActiveClass() {
  const urlParams = new URLSearchParams(window.location.search)
  const sortBy = urlParams.get("sort_by")
  document.querySelectorAll('input[name="sort_by"]').forEach((radio) => {
    const label = radio.closest(".mobile-facets__label")
    if (!label) return
    if (!sortBy) {
      // No sort selected: visually highlight "Featured"
      if (radio.value === "relevance") {
        // Add only if not already active
        label.classList.add("active")
        // (Do NOT check radio!)
      } else {
        label.classList.remove("active")
      }
      radio.checked = false // ensure none checked
    } else {
      // With a sort: highlight the matching radio
      radio.checked = radio.value === sortBy
      label.classList.toggle("active", radio.value === sortBy)
    }
  })
}

function debounce(func, wait = 150) {
  let timeout
  return function (...args) {
    clearTimeout(timeout)
    timeout = setTimeout(() => func.apply(this, args), wait)
  }
}

// Prevent pill flicker: lock rendering for 200ms after quick filter click
window.justClickedQuickFilter = false
window.justClickedQuickFilterTimestamp = null
window.pillOrderArr = window.pillOrderArr || []
let wasDrawerOpen = false
let wasSortByChanged = false
// ============================================================================
// Sort Label Sync Helper
// ============================================================================
function updateSelectedSortCustomLabel() {
  // Try: Checked drawer radio
  let sortLabel = ""
  const checkedSort = document.querySelector('input[name="sort_by"]:checked')
  if (checkedSort) {
    let labelElem =
      document.querySelector(`label[for="${checkedSort.id}"]`) ||
      checkedSort.closest("label") ||
      checkedSort.parentElement
    if (labelElem) sortLabel = labelElem.textContent.trim()
  }
  // Fallback: <select>
  if (!sortLabel) {
    const sortDropdown = document.querySelector('select[name="sort_by"]')
    if (sortDropdown) {
      sortLabel = sortDropdown.options[sortDropdown.selectedIndex]?.text || ""
    }
  }
  // Fallback: custom radio group
  if (!sortLabel) {
    const customRadio = document.querySelector(
      '.multiple-custom-sort-options input[name="sort_by"]:checked',
    )
    if (customRadio) {
      const labelElem = customRadio
        .closest(".custom-search-sort")
        ?.querySelector(".custom-radio-checkbox-label")
      if (labelElem) sortLabel = labelElem.textContent.trim()
    }
  }
  // Write to DOM
  const customSortDiv = document.querySelector(".selected-sort-custom")
  if (customSortDiv && sortLabel) {
    customSortDiv.textContent = sortLabel
  }
}
// ============================================================================
// Pill Logic, Event Bindings, AJAX/Product Grid Updates, Drawer Sync, Show More
// ============================================================================

// Main entry point: handles pill logic, event bindings, AJAX loading, drawer sync, and show more
document.addEventListener("DOMContentLoaded", () => {
  // --- [PillCreate] Function to inject unmatched "Most Popular" pills from URL ---
  // Normalizes the label for "Most Popular" filters for comparison
  function normalizeMostPopular(val) {
    return decodeURIComponent(val || "")
      .replace(/\+/g, " ")
      .replace(/%20/g, " ")
      .replace(/\s+/g, " ")
      .replace(/[^a-z0-9 ]+/gi, "")
      .toLowerCase()
      .trim()
  }
  // Injects unmatched "Most Popular" pills from the URL that are checked in the drawer but not present as quick filter buttons
  function createUnmatchedMostPopularPills() {
    // Only run this logic for the "most_popular" filter context
    const params = new URLSearchParams(window.location.search)
    const activeMostPopularFilters =
      params.getAll("filter.p.m.custom.most_popular") || []
    const pillsContainer = document.querySelector(".quick-filters-container")
    if (!pillsContainer) return

    function normalizeMostPopular(val) {
      return decodeURIComponent(val || "")
        .replace(/\+/g, " ")
        .replace(/%20/g, " ")
        .replace(/\s+/g, " ")
        .replace(/[^a-z0-9 ]+/gi, "")
        .toLowerCase()
        .trim()
    }

    activeMostPopularFilters.forEach((label) => {
      if (!label) return
      // Compare filter param values, not just label/text, for language-agnostic deduplication
      const quickBtn = Array.from(
        document.querySelectorAll(".quick-filter-main .custom-button a"),
      ).find((a) => {
        const btnUrl = new URL(a.href, location.origin)
        const btnVal = btnUrl.searchParams.get("filter.p.m.custom.most_popular")
        return (
          btnVal && btnVal.trim().toLowerCase() === label.trim().toLowerCase()
        )
      })
      if (quickBtn && quickBtn.classList.contains("selected")) {
        return
      }
      // Only show pill if option is checked in drawer
      const drawerCheckbox = Array.from(
        document.querySelectorAll(
          'input[name="filter.p.m.custom.most_popular"]',
        ),
      ).find(
        (input) =>
          decodeURIComponent(input.value).trim().toLowerCase() ===
          label.trim().toLowerCase(),
      )
      if (!drawerCheckbox || !drawerCheckbox.checked) return

      // Only create pill if NOT already present (prevents duplication)
      const pillExists = Array.from(
        pillsContainer.querySelectorAll(
          '.quick-filter-pill[data-p^="filter.p.m.custom.most_popular|"]',
        ),
      ).some(
        (pill) =>
          (pill.getAttribute("data-p")?.split("|")[1] || pill.textContent)
            .trim()
            .toLowerCase() === label.trim().toLowerCase(),
      )
      if (pillExists) return

      // Otherwise, create the pill
      const pill = document.createElement("span")
      pill.className = "quick-filter-pill"
      pill.textContent = label
      pill.dataset.p = `filter.p.m.custom.most_popular|${label}`

      pill.addEventListener("click", function () {
        const param = pill.getAttribute("data-p")
        if (param) {
          const [name, value] = param.split("|")
          const urlParams = new URLSearchParams(window.location.search)
          const values = urlParams.getAll(name)
          const newValues = values.filter((v) => v !== value)
          urlParams.delete(name)
          newValues.forEach((v) => urlParams.append(name, v))
          history.replaceState(
            {},
            "",
            `${window.location.pathname}?${urlParams}`,
          )
          if (typeof loadContent2 === "function") {
            loadContent2(window.location.pathname + "?" + urlParams.toString())
          }
        }
      })

      if (pill && pillsContainer) {
        pillsContainer.insertBefore(pill, pillsContainer.firstChild)
      }
    })
  }
  // [QuickScroll] Setup quick filter pill click handler to set skipScrollBecauseOfQuickFilterClick
  document.querySelectorAll(".quick-filter-pill").forEach((pill) => {
    pill.addEventListener("click", () => {
      skipScrollBecauseOfQuickFilterClick = true
      setTimeout(() => {
        skipScrollBecauseOfQuickFilterClick = false
      }, 500)
    })
  })
  const quickWrapper = document.querySelector(".quick-filter-main")
  if (!quickWrapper) return

  const drawerSelector = "#FacetFiltersFormMobile, #FacetFiltersForm"
  let drawerForm = document.querySelector(drawerSelector)
  const currency = Shopify.currency?.symbol || "$"
  let userSelectedSort = false
  let userManuallySorted = false

  const quickContainer = document.createElement("div")
  quickContainer.className = "quick-filters-container"
  // Always append quickContainer safely at the leftmost position
  if (quickWrapper && quickContainer instanceof HTMLElement) {
    quickWrapper.appendChild(quickContainer)
  }

  // --- [REMOVED] Ensure quick filters container uses flex layout and order property ---
  // The pill order is controlled entirely by the JS array (pillOrderArr) and insertion point,
  // not by CSS flex-direction or order. All pills are inserted using
  // quickContainer.insertBefore(pill, quickContainer.firstChild), so the newest pill appears leftmost.

  const clearFilters =
    document.querySelector(".active-facets__button-remove").textContent ||
    "Clear Filters"
  const clearAllBtn = document.createElement("button")
  clearAllBtn.textContent = clearFilters
  clearAllBtn.className =
    "quick-filter-clear-all quick-filter-clear-all-desktop button button--tertiary"
  clearAllBtn.style.display = "inline-block"
  quickWrapper.appendChild(clearAllBtn)

  const drawerDetails = document.querySelector(".mobile-facets__disclosure")

  if (drawerDetails) {
    drawerDetails.addEventListener("toggle", () => {
      if (drawerDetails.open) {
        // Reopen all inner <details> inside drawer
        drawerDetails
          .querySelectorAll(".mobile-facets__details")
          .forEach((section) => {
            section.open = true
          })
      }
    })
  }

  // Utility: Debounces a function call (delays execution until after wait ms have elapsed)
  function debounce(func, wait = 300) {
    let timeout
    return (...args) => {
      clearTimeout(timeout)
      timeout = setTimeout(() => func.apply(this, args), wait)
    }
  }
  const debouncedUpdateURL = debounce(updateURL, 150)

  // Extracts all filter values from both desktop and mobile forms into an object
  function getFilters() {
    const filters = {}
    const forms = [
      document.querySelector("#FacetFiltersForm"),
      document.querySelector("#FacetFiltersFormMobile"),
    ]

    forms.forEach((form) => {
      if (!form) return

      const data = new FormData(form)
      for (const [key, value] of data.entries()) {
        const trimmed = value?.toString().trim()

        if (!trimmed) continue

        const isPriceFilter =
          key === "filter.v.price.gte" || key === "filter.v.price.lte"
        if (isPriceFilter && trimmed === "") continue

        filters[key] = filters[key] || []
        filters[key].push(trimmed)
      }
    })

    // PATCH: Only include sort_by if it's NOT 'manual', or if user selected, or in URL
    const params = new URLSearchParams(window.location.search)
    if (
      filters["sort_by"] &&
      filters["sort_by"][0] === "manual" &&
      !userSelectedSort &&
      (!params.has("sort_by") || params.get("sort_by") !== "manual")
    ) {
      delete filters["sort_by"]
    }
    return filters
  }

  // Converts filter object into a URLSearchParams string, handling arrays and primitives
  function buildCleanParams(params = {}) {
    const cleanParams = new URLSearchParams()

    for (const [key, value] of Object.entries(params)) {
      if (
        typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean"
      ) {
        cleanParams.set(key, value)
      } else if (Array.isArray(value)) {
        for (const val of value) {
          cleanParams.append(key, val)
        }
      }
    }

    return cleanParams.toString()
  }

  // Updates the URL with new filters and triggers AJAX reload of content
  async function updateURL(filters) {
    console.log(
      "[AJAX] updateURL called with filters:",
      filters,
      new Error().stack,
    )
    // Remove default sort unless user manually selected it
    if (!userManuallySorted && filters["sort_by"]?.[0] === "manual") {
      delete filters["sort_by"]
    }

    const ps = buildCleanParams(filters)
    const newUrl = ps.toString()
      ? `${window.location.pathname}?${ps}`
      : window.location.pathname
    if (filters["sort_by"]?.[0] === "manual") {
      delete filters["sort_by"] // remove default unless user changed it
    }
    history.replaceState({}, "", newUrl)
    shouldRestoreScroll = false
    loadContent(filters)
  }
  window.updateURL = updateURL

  // Extracts available "Most Popular" options from the DOM for button/pill rendering
  function extractLiveMostPopularOptionsFromDOM(container = document) {
    return Array.from(
      container.querySelectorAll(
        'input[name="filter.p.m.custom.most_popular"]',
      ),
    )
      .filter((input) => !input.disabled)
      .map((input) => decodeURIComponent(input.value?.trim() || ""))
  }

  let mostPopularOptionsFromResponse = extractLiveMostPopularOptionsFromDOM()

  let isLoadingContent = false
  // Loads filtered product grid and related UI via AJAX, replaces DOM sections, and rebinds events
  async function loadContent(filters) {
    wasDrawerOpen = false
    shouldRestoreScroll = true
    // --- PATCH: Prevent double AJAX and save scroll position ---
    if (window._isLoadingContent) return
    // --- PATCH: Smooth mobile flicker prevention ---
    const grid = document.querySelector("#ProductGridContainer")
    if (grid) grid.classList.add("loading-ajax")

    // Save scroll position relative to grid (not window)
    let scrollOffset = 0
    if (grid) {
      const gridRect = grid.getBoundingClientRect()
      scrollOffset = window.scrollY - gridRect.top
    }
    window._isLoadingContent = true
    const previousScroll = window.scrollY || document.documentElement.scrollTop
    currentPage = 1
    try {
      // Disable all quick filter pills during loading
      document
        .querySelectorAll(".quick-filter-pill")
        .forEach((pill) => pill.classList.add("disabled"))

      const cleanUrl = `${window.location.pathname}?${buildCleanParams(filters)}`
      const res = await fetch(cleanUrl)
      if (!res.ok) {
        window._isLoadingContent = false // PATCH: clear loading flag on error
        return
      }
      const html = await res.text()
      const tmp = new DOMParser().parseFromString(html, "text/html")

      // Replace product grid
      const newGrid = tmp.querySelector("#ProductGridContainer")
      const curGrid = document.querySelector("#ProductGridContainer")
      if (newGrid && curGrid) {
        curGrid.innerHTML = newGrid.innerHTML
        // --- Client-side title sort for search results (safe version) ---
        const urlParams = new URLSearchParams(window.location.search)
        const sortBy = urlParams.get("sort_by")
        if (
          (sortBy === "title-ascending" || sortBy === "title-descending") &&
          curGrid
        ) {
          // Only sort if the grid exists and is a product grid
          const grid = curGrid.querySelector("ul.product-grid")
          if (grid) {
            // Only sort direct children that are product items
            const items = Array.from(grid.children).filter((li) =>
              li.classList.contains("grid__item"),
            )
            items.sort((a, b) => {
              const aTitle = (
                a.querySelector(
                  ".card__heading, .product-title, .card__information a, .full-unstyled-link",
                )?.textContent || ""
              )
                .trim()
                .toLowerCase()
              const bTitle = (
                b.querySelector(
                  ".card__heading, .product-title, .card__information a, .full-unstyled-link",
                )?.textContent || ""
              )
                .trim()
                .toLowerCase()
              if (aTitle < bTitle) return sortBy === "title-ascending" ? -1 : 1
              if (aTitle > bTitle) return sortBy === "title-ascending" ? 1 : -1
              return 0
            })
            // Remove all product items, then re-append in sorted order
            items.forEach((item) => grid.appendChild(item))
          } else {
            console.log("[DEBUG] Product grid not found for sorting.")
          }
        }
        if (typeof theme_custom?.percussiveMassageSlider === "function") {
          theme_custom.percussiveMassageSlider()
        }
        // Delay count update to ensure grid has been rendered
        setTimeout(() => {
          const updatedGrid = document.querySelector("#ProductGridContainer")
          const visibleCount =
            updatedGrid?.querySelectorAll(".grid__item").length || 0
          const countElem = document.querySelector(".custom-show-product")
          if (countElem) countElem.textContent = visibleCount.toString()
        }, 0)
      }
      const totalElem = document.querySelector(".custom-total-product")

      const newTotalElem = tmp.querySelector(".custom-total-product")
      if (newTotalElem && totalElem) {
        totalElem.textContent = newTotalElem.textContent
      }

      const progress = document.querySelector(".load-more-progress-bar")
      const countElem = document.querySelector(".custom-show-product")
      if (progress && countElem && totalElem) {
        const total = parseInt(totalElem.textContent || "0")
        const shown = parseInt(countElem.textContent || "0")
        progress.style.width = `${(shown / total) * 100}%`
      }

      // Replace product count
      const newCount = tmp.querySelector("#ProductCount, #ProductCountDesktop")
      const curCount = document.querySelector(
        "#ProductCount, #ProductCountDesktop",
      )
      if (newCount && curCount)
        curCount.innerHTML = newCount.innerHTML.replace("products", "Products")

      // Replace drawer filters (mobile) - preserve scroll and avoid full replacement
      const newDrawer = tmp.querySelector("#FacetFiltersFormMobile")
      const curDrawer = document.querySelector("#FacetFiltersFormMobile")
      if (curDrawer && newDrawer) {
        const innerOld = curDrawer.querySelector(".mobile-facets__inner")
        const innerNew = newDrawer.querySelector(".mobile-facets__inner")

        if (innerOld && innerNew) {
          const scrollTop = innerOld.scrollTop

          const mainOld = innerOld.querySelector(".mobile-facets__main")
          const mainNew = innerNew.querySelector(".mobile-facets__main")

          if (mainOld && mainNew) {
            mainOld.innerHTML = mainNew.innerHTML
          }

          setTimeout(() => {
            innerOld.scrollTop = scrollTop
            syncAll() // rebind filters
          }, 0)
        }
      }

      const newDrawerDesktop = tmp.querySelector("#FacetFiltersForm")
      const curDrawerDesktop = document.querySelector("#FacetFiltersForm")
      if (newDrawerDesktop && curDrawerDesktop) {
        const scrollY = curDrawerDesktop.scrollTop
        curDrawerDesktop.replaceWith(newDrawerDesktop)
        newDrawerDesktop.scrollTop = scrollY
      }

      // ✅ Replace .load-more-part after filters are applied
      const newLoadMore = tmp.querySelector(".load-more-part")
      const curLoadMore = document.querySelector(".load-more-part")
      if (newLoadMore && curLoadMore) {
        curLoadMore.replaceWith(newLoadMore.cloneNode(true))
      }

      // Re-extract most popular options
      mostPopularOptionsFromResponse = extractLiveMostPopularOptionsFromDOM(tmp)

      // Rebind everything
      syncAll()
      // Re-bind Show More button using global rebind
      setTimeout(() => {
        rebindShowMoreButton()
      }, 0)
      // --- Remove unavailable unmatched Most Popular pills after content load ---
      removeUnavailableUnmatchedPills(html)
      // --- [PATCH] Ensure unmatched Most Popular pills are created after DOM/filter updates ---
      if (typeof createUnmatchedMostPopularPills === "function") {
        requestAnimationFrame(() => {
          setTimeout(() => {
            createUnmatchedMostPopularPills()
            // [PATCH] Ensure pills are cleaned up after all DOM and pill rendering is complete
            setTimeout(removeUnavailableUnmatchedPills, 100)
          }, 100)
        })
      }
      // --- Update product count display at the end of loadContent ---
      updateProductCountDisplay()
      filterSelectionTag.track()
    } catch (e) {
      window._isLoadingContent = false // PATCH: clear loading flag on error
    } finally {
      isLoadingContent = false
      document
        .querySelectorAll(".quick-filter-pill")
        .forEach((pill) => pill.classList.remove("disabled"))
      if (typeof attachMobileClearHandler === "function")
        attachMobileClearHandler()
    }
    window.justClickedQuickFilter = false
    window.justClickedQuickFilterTimestamp = null

    updateActiveSortLabel()
    toggleClearFiltersVisibility()
    updateDrawerSortActiveClass()

    // --- FINAL: Client-side title sort for search results (must run last) ---
    const urlParams = new URLSearchParams(window.location.search)
    const sortBy = urlParams.get("sort_by")
    if (sortBy === "title-ascending" || sortBy === "title-descending") {
      const curGrid = document.querySelector("#ProductGridContainer")
      if (curGrid) {
        const grid = curGrid.querySelector("ul.product-grid")
        if (grid) {
          const items = Array.from(grid.children).filter((li) =>
            li.classList.contains("grid__item"),
          )
          items.sort((a, b) => {
            const aTitle = (
              a.querySelector(
                ".card__heading, .product-title, .card__information a, .full-unstyled-link",
              )?.textContent || ""
            )
              .trim()
              .toLowerCase()
            const bTitle = (
              b.querySelector(
                ".card__heading, .product-title, .card__information a, .full-unstyled-link",
              )?.textContent || ""
            )
              .trim()
              .toLowerCase()
            if (aTitle < bTitle) return sortBy === "title-ascending" ? -1 : 1
            if (aTitle > bTitle) return sortBy === "title-ascending" ? 1 : -1
            return 0
          })
          items.forEach((item) => grid.appendChild(item))
        }
      }
    }
    // --- PATCH: Smooth mobile flicker prevention (restore scroll & fade out overlay) ---
    setTimeout(() => {
      if (grid) grid.classList.remove("loading-ajax")
      // Only restore scroll if NOT a filter, sort, or pill change (i.e., only on direct nav/back/forward)
      if (
        shouldRestoreScroll &&
        grid &&
        !window.justClickedQuickFilter &&
        !wasDrawerOpen &&
        !wasQuickFilterPillClick &&
        !wasSortByChanged // <--- Add this!
      ) {
        const newGridRect = grid.getBoundingClientRect()
        window.scrollTo({
          top: newGridRect.top + window.scrollY + scrollOffset,
          behavior: "auto",
        })
      }
      // Always reset these after
      shouldRestoreScroll = true
      wasDrawerOpen = false
      wasQuickFilterPillClick = false
      window.justClickedQuickFilter = false
      window._isLoadingContent = false
      checkProductCardsPromoTextHeight()
    }, 100)
  }
  window.loadContent = loadContent

  // --- Helper to remove unavailable or unmatched Most Popular pills ---
  // Removes unmatched "Most Popular" pills that are no longer available/checked in the drawer
  function removeUnavailableUnmatchedPills() {
    setTimeout(() => {
      const pills = Array.from(
        document.querySelectorAll(
          '.quick-filter-pill[data-p^="filter.p.m.custom.most_popular|"]',
        ),
      )
      pills.forEach((pill) => {
        const pillRaw = pill.getAttribute("data-p")?.split("|")[1] || ""
        const normalized = pillRaw
          .replace(/\+/g, " ")
          .replace(/%20/g, " ")
          .replace(/\s+/g, " ")
          .replace(/[^a-z0-9 ]+/gi, "")
          .toLowerCase()
          .trim()
        const drawerCheckbox = Array.from(
          document.querySelectorAll(
            'input[name="filter.p.m.custom.most_popular"]',
          ),
        ).find((input) => {
          return (
            (input.value || "")
              .replace(/\+/g, " ")
              .replace(/%20/g, " ")
              .replace(/\s+/g, " ")
              .replace(/[^a-z0-9 ]+/gi, "")
              .toLowerCase()
              .trim() === normalized
          )
        })
        if (!drawerCheckbox || !drawerCheckbox.checked) {
          pill.remove()
        }
      })
    }, 50)
  }

  // Sets up price filter input events to sanitize and trigger AJAX updates
  function setupPriceFilters() {
    if (!drawerForm) return

    const priceInputs = [
      drawerForm.querySelector('input[name="filter.v.price.gte"]'),
      drawerForm.querySelector('input[name="filter.v.price.lte"]'),
    ].filter(Boolean)

    priceInputs.forEach((input) => {
      // Clone input to remove problematic event listeners
      const newInput = input.cloneNode(true)
      input.replaceWith(newInput)

      // Store current cursor position
      let cursorPosition = 0

      newInput.addEventListener("keydown", (e) => {
        cursorPosition = e.target.selectionStart
        if (e.key === "Enter") {
          applyPriceFilters()
        }
      })

      newInput.addEventListener("input", (e) => {
        const newValue = e.target.value.replace(/[^0-9]/g, "")
        if (newValue !== e.target.value) {
          e.target.value = newValue
          newInput.setSelectionRange(cursorPosition, cursorPosition)
        }
      })

      newInput.addEventListener("blur", debounce(applyPriceFilters, 300))
    })
  }

  // Clears all sort radio buttons and removes their active states
  function clearSortRadios() {
    // Uncheck all sort radios
    document
      .querySelectorAll('.mobile-facets__checkbox[type="radio"]')
      .forEach((radio) => {
        radio.checked = false
      })
    // Remove active class from labels
    document.querySelectorAll(".mobile-facets__label").forEach((label) => {
      label.classList.remove("active")
    })
  }

  // Rebinds price range input events in <price-range> components to trigger AJAX updates
  function rebindPriceRangeInputs() {
    const priceComponents = document.querySelectorAll("price-range")
    priceComponents.forEach((range) => {
      const minInput = range.querySelector('input[name="filter.v.price.gte"]')
      const maxInput = range.querySelector('input[name="filter.v.price.lte"]')

      if (!minInput || minInput.classList.contains("price-bound")) return

      const updatePrice = () => {
        const filters = getFilters()
        const minVal = minInput.value.trim()
        const maxVal = maxInput.value.trim()

        // Only include valid prices
        if (minVal && !isNaN(minVal)) {
          filters["filter.v.price.gte"] = [minVal]
        } else {
          delete filters["filter.v.price.gte"]
        }

        if (maxVal && !isNaN(maxVal)) {
          filters["filter.v.price.lte"] = [maxVal]
        } else {
          delete filters["filter.v.price.lte"]
        }

        if (minVal || maxVal) {
          shouldRestoreScroll = false
          updateURL(filters)
        }
      }

      // Blur triggers AJAX update
      minInput.addEventListener("blur", updatePrice)
      maxInput.addEventListener("blur", updatePrice)

      // Enter key
      minInput.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault()
          updatePrice()
        }
      })
      maxInput.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault()
          updatePrice()
        }
      })

      // Prevent instant reload on typing
      minInput.addEventListener("input", (e) => e.stopPropagation())
      maxInput.addEventListener("input", (e) => e.stopPropagation())

      // Mark as bound
      minInput.classList.add("price-bound")
      maxInput.classList.add("price-bound")
    })
  }

  // Removes the 'data-max' attribute from price range inputs to allow any value
  function fixPriceRangeDataMax() {
    document
      .querySelectorAll('price-range input[name="filter.v.price.gte"]')
      .forEach((input) => {
        if (input.hasAttribute("data-max")) {
          input.removeAttribute("data-max") // 🛠 remove limit
        }
      })

    document
      .querySelectorAll('price-range input[name="filter.v.price.lte"]')
      .forEach((input) => {
        if (input.hasAttribute("data-max")) {
          input.removeAttribute("data-max") // 🛠 remove limit
        }
      })
  }

  // Safely binds blur and Enter key events to price inputs to trigger filter updates
  function bindPriceEventsSafely() {
    document
      .querySelectorAll('price-range input[name^="filter.v.price"]')
      .forEach((input) => {
        if (input.classList.contains("price-bound")) return

        input.addEventListener("blur", () => {
          const filters = getFilters()
          shouldRestoreScroll = false
          updateURL(filters)
        })

        input.addEventListener("keydown", (e) => {
          if (e.key === "Enter") {
            e.preventDefault()
            const filters = getFilters()
            shouldRestoreScroll = false
            updateURL(filters)
          }
        })

        input.classList.add("price-bound")
      })
  }

  // Binds the drawer clear button to reset filters and trigger AJAX reload, preserving q and options[prefix]
  function setupDrawerClearButton() {
    const drawerClearBtn = document.querySelector(
      ".mobile-facets__clear.button--secondary",
    )
    if (!drawerClearBtn || drawerClearBtn.classList.contains("bound")) return
    drawerClearBtn.removeEventListener("click", resetAllFiltersAndReload)
    drawerClearBtn.addEventListener("click", function (e) {
      e.preventDefault()
      resetAllFiltersAndReload()
    })
    drawerClearBtn.classList.add("bound")
  }

  // Named event handlers for sort radios and dropdown
  function handleSortChange(e) {
    const radio = e.target
    if (!radio || !radio.value) return
    const filters = getFilters()
    filters["sort_by"] = [radio.value]
    let pillOrderArr = getPillOrderArr()
    pillOrderArr = pillOrderArr.filter(([k, v]) => !(k === "sort_by"))
    pillOrderArr.unshift(["sort_by", radio.value])
    setPillOrderArr(pillOrderArr)
    userSelectedSort = true // Only set true when user actively selects sort
    userManuallySorted = true
    // No longer updateURL or updateSelectedSortCustomLabel here
  }
  function onSortRadioChange(e) {
    userSelectedSort = true
    userManuallySorted = true
    handleSortChange(e)

    const url = new URL(window.location.href)
    url.searchParams.set("sort_by", e.target.value)
    history.replaceState({}, "", url.toString())

    const filters = getFilters()
    filters["sort_by"] = [e.target.value]
    wasDrawerOpen = !!document.querySelector(".mobile-facets__disclosure[open]")
    wasSortByChanged = true // <--- Add this!
    shouldRestoreScroll = false // (already present, that's fine)
    debouncedUpdateURL(filters)
    updateSelectedSortCustomLabel()
  }
  function onSortDropdownChange(e) {
    userSelectedSort = true
    userManuallySorted = true
    const dropdown = e.target
    if (!dropdown || !dropdown.value) return

    // Update the browser URL param manually (before AJAX reload)
    const url = new URL(window.location.href)
    url.searchParams.set("sort_by", dropdown.value)
    history.replaceState({}, "", url.toString())

    // Now sync the dropdown value explicitly (prevents reset)
    dropdown.value = dropdown.value

    const filters = getFilters()
    filters["sort_by"] = [dropdown.value]
    let pillOrderArr = getPillOrderArr()
    pillOrderArr = pillOrderArr.filter(([k, v]) => !(k === "sort_by"))
    pillOrderArr.unshift(["sort_by", dropdown.value])
    setPillOrderArr(pillOrderArr)
    debouncedUpdateURL(filters)
    updateSelectedSortCustomLabel()
  }

  // Rebinds all filter, sort, and price events; syncs UI state; ensures pill and drawer consistency
  function syncAll() {
    // Rebind drawerForm element
    drawerForm = document.querySelector(drawerSelector)

    // Prevent Dawn's default form submission behavior
    document
      .querySelectorAll("#FacetFiltersForm, #FacetFiltersFormMobile")
      .forEach((form) => {
        form.addEventListener("submit", (e) => e.preventDefault())
      })

    // Rebind all checkbox events to submit filters
    if (drawerForm) {
      drawerForm.querySelectorAll('input[type="checkbox"]').forEach((input) => {
        if (!input.classList.contains("bound")) {
          input.addEventListener("change", (e) => {
            shouldRestoreScroll = false
            wasQuickFilterPillClick = true
            e.preventDefault()
            e.stopPropagation()
            window.quickFilterJustAdded = true
            const key = input.name
            const value = input.value
            let pillOrderArr = getPillOrderArr()
            pillOrderArr = pillOrderArr.filter(
              ([k, v]) => !(k === key && v === value),
            )
            if (input.checked) {
              pillOrderArr.unshift([key, value])
            }
            setPillOrderArr(pillOrderArr)
            wasDrawerOpen = !!document.querySelector(
              ".mobile-facets__disclosure[open]",
            )
            shouldRestoreScroll = false
            updateURL(getFilters())
          })
          input.classList.add("bound")
        }
      })
    }

    const sortRadios = document.querySelectorAll('input[name="sort_by"]')

    // Remove any prior change listeners and add only the named handler
    sortRadios.forEach((radio) => {
      radio.removeEventListener("change", onSortRadioChange)
      radio.addEventListener("change", onSortRadioChange)
    })
    let sortDropdown = document.querySelector('select[name="sort_by"]')
    if (sortDropdown) {
      sortDropdown.removeEventListener("change", onSortDropdownChange)
      sortDropdown.addEventListener("change", onSortDropdownChange)
    }

    // Rebind price input events (call only once)
    bindPriceEventsSafely()
    rebindPriceRangeInputs()
    setupPriceFilters()
    const filters = getFilters()

    if (drawerForm) {
      drawerForm.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
        cb.checked = !!filters[cb.name]?.includes(cb.value)
      })

      const minInput = drawerForm.querySelector(
        'input[name="filter.v.price.gte"]',
      )
      const maxInput = drawerForm.querySelector(
        'input[name="filter.v.price.lte"]',
      )
      if (minInput) minInput.value = filters["filter.v.price.gte"]?.[0] || ""
      if (maxInput) maxInput.value = filters["filter.v.price.lte"]?.[0] || ""

      // Open all filter accordions
      drawerForm.querySelectorAll("details").forEach((d) => (d.open = true))
    }

    // --- FINAL: Always sync custom radio group checked/active and label with URL ---
    ;(function () {
      const urlParams = new URLSearchParams(window.location.search)
      const sortBy = urlParams.get("sort_by") || "manual"
      let foundActive = false

      document
        .querySelectorAll('.multiple-custom-sort-options input[name="sort_by"]')
        .forEach((radio) => {
          const isActive = radio.value === sortBy
          radio.checked = isActive
          const parent = radio.closest(".custom-search-sort")
          const label = parent?.querySelector(".custom-radio-checkbox-label")
          if (parent) parent.classList.toggle("active", isActive)
          if (label) label.classList.toggle("active", isActive)
          if (isActive) foundActive = true
        })

      // If no radio matches sort_by, fallback to "manual"
      if (!foundActive) {
        document
          .querySelectorAll(
            '.multiple-custom-sort-options input[name="sort_by"]',
          )
          .forEach((radio) => {
            const isFeatured = radio.value === "relevance"
            radio.checked = isFeatured
            const parent = radio.closest(".custom-search-sort")
            const label = parent?.querySelector(".custom-radio-checkbox-label")
            if (parent) parent.classList.toggle("active", isFeatured)
            if (label) label.classList.toggle("active", isFeatured)
          })
      }

      // Update selected sort text
      const selectedSortCustomDiv = document.querySelector(
        ".selected-sort-custom",
      )
      if (selectedSortCustomDiv) {
        const activeLabel = document.querySelector(
          ".custom-search-sort.active .custom-radio-checkbox-label",
        )
        selectedSortCustomDiv.textContent = activeLabel
          ? activeLabel.textContent.trim()
          : window.mostRelevantLabel || "Most relevant"
      }
    })()

    // (Optional) Remove syncing for <select name="sort_by"> unless needed for other templates
    // --- Ensure sort dropdown always matches current sort on initial load & AJAX ---
    /*
    let sortDropdown = document.querySelector('select[name="sort_by"]');
    if (sortDropdown) {
      // Try to match by value; if missing or invalid, fallback to first <option>
      const hasValue = !!sortDropdown.querySelector(`option[value="${sortBy}"]`);
      if (sortBy && hasValue) {
        sortDropdown.value = sortBy;
      } else {
        sortDropdown.selectedIndex = 0;
      }
      // Also, trigger a change event to sync radios and label, if needed
      sortDropdown.dispatchEvent(new Event("change"));
    }
    */

    const urlParams = new URLSearchParams(window.location.search)
    const sortBy = urlParams.get("sort_by") || "manual"
    document
      .querySelectorAll('.mobile-facets__checkbox[type="radio"]')
      .forEach((radio) => {
        const isChecked = radio.value === sortBy
        radio.checked = isChecked
        const label = radio.closest(".mobile-facets__label")
        if (label) {
          if (isChecked && !radio.dataset.default) {
            label.classList.add("active")
          } else {
            // label.classList.remove("active")
          }
        }
      })

    // Ensure at least one sort radio is checked and active ("manual"/Featured as fallback)

    // Drawer sort_by radios
    updateDrawerSortActiveClass()

    // (SYNC of custom radio group handled by FINAL block above)

    // --- Keep sort_by dropdown and drawer radios in sync ---
    // (Handled above with onSortRadioChange and onSortDropdownChange)

    // --- Custom sort radio group ↔ standard dropdown ↔ drawer sync ---
    // 1. When a custom radio is changed, update standard dropdown and drawer radios
    // (No need to update .checked/.active on custom radio group here, handled by FINAL block)
    document
      .querySelectorAll('.multiple-custom-sort-options input[name="sort_by"]')
      .forEach((customRadio) => {
        customRadio.addEventListener("change", function () {
          // Inserted at the top: track if drawer was open
          wasDrawerOpen = !!document.querySelector(
            ".mobile-facets__disclosure[open]",
          )
          // Update drawer radios
          document
            .querySelectorAll('input[name="sort_by"]')
            .forEach((radio) => {
              if (radio !== customRadio)
                radio.checked = radio.value === customRadio.value
            })
          // Update standard sort_by <select>
          sortDropdown = document.querySelector('select[name="sort_by"]')
          if (sortDropdown && sortDropdown.value !== customRadio.value) {
            sortDropdown.value = customRadio.value
            sortDropdown.dispatchEvent(new Event("change"))
          }
          // Do NOT update .checked/.active or label here, handled by FINAL block
        })
      })

    // 2. When a drawer radio or standard dropdown is changed, update the custom radio group
    // No-op updateCustomSortRadios: syncing of .checked/.active handled by FINAL block
    const updateCustomSortRadios = function (selectedValue) {
      // No-op: syncing handled by FINAL block
    }

    // Drawer sort_by
    document
      .querySelectorAll('input[name="sort_by"]')
      .forEach((drawerRadio) => {
        // Only update custom radios and dropdown, don't stack sort AJAX
        drawerRadio.removeEventListener("change", updateCustomSortRadiosHandler)
        drawerRadio.addEventListener("change", updateCustomSortRadiosHandler)
      })
    function updateCustomSortRadiosHandler(e) {
      const drawerRadio = e.target
      updateCustomSortRadios(drawerRadio.value)
      // Optionally: also update <select> if you have it on the page
      let sortDropdown = document.querySelector('select[name="sort_by"]')
      if (sortDropdown && sortDropdown.value !== drawerRadio.value) {
        sortDropdown.value = drawerRadio.value
        sortDropdown.dispatchEvent(new Event("change"))
      }
      // Do NOT update .checked/.active or label here, handled by FINAL block
    }

    // Standard <select>
    let sortDropdownForCustom = document.querySelector('select[name="sort_by"]')
    // --- Ensure sort dropdown always matches current sort on initial load & AJAX ---
    const urlParamsSortDropdown = new URLSearchParams(window.location.search)
    const sortBySortDropdown = urlParamsSortDropdown.get("sort_by")
    if (sortDropdownForCustom) {
      // Try to match by value; if missing or invalid, fallback to first <option>
      const hasValue = !!sortDropdownForCustom.querySelector(
        `option[value="${sortBySortDropdown}"]`,
      )
      if (sortBySortDropdown && hasValue) {
        sortDropdownForCustom.value = sortBySortDropdown
      } else {
        sortDropdownForCustom.selectedIndex = 0
      }
    }
    // Now bind event
    if (sortDropdownForCustom) {
      sortDropdownForCustom.removeEventListener("change", onSortDropdownChange)
      sortDropdownForCustom.addEventListener("change", onSortDropdownChange)
      sortDropdownForCustom.addEventListener("change", function () {
        updateCustomSortRadios(sortDropdownForCustom.value)
        // Also update drawer radios
        document
          .querySelectorAll('input[name="sort_by"]')
          .forEach((drawerRadio) => {
            drawerRadio.checked =
              drawerRadio.value === sortDropdownForCustom.value
          })
        // Do NOT update .checked/.active or label here, handled by FINAL block
      })
    }

    // Only retain sort_by in filters if user actually selected it via URL
    // if (!sortBy) {
    //   delete filters["sort_by"]
    // }

    renderQuick(filters)
    // --- [PATCH: Ensure Sort Pill Label Is Always Up To Date After AJAX, Both Radios & Select] ---
    setTimeout(function () {
      const sortByPill = document.querySelector(
        ".quick-filter-pill[data-sort-by]",
      )
      let sortLabel = null
      // Prefer radio label
      const sortRadio = document.querySelector('input[name="sort_by"]:checked')
      if (sortRadio) {
        let labelElem =
          document.querySelector(`label[for="${sortRadio.id}"]`) ||
          sortRadio.closest("label") ||
          sortRadio.parentElement
        if (labelElem) {
          sortLabel = labelElem.textContent.trim()
        }
      } else {
        // Fallback: select box
        const sortSelect = document.querySelector('select[name="sort_by"]')
        if (sortSelect) {
          const selected = sortSelect.querySelector("option:checked")
          if (selected) {
            sortLabel = selected.textContent.trim()
          }
        }
      }
      if (sortByPill && sortLabel) {
        sortByPill.textContent = sortLabel
      }
    }, 80)
    // Force quick filters container to left on first load
    const pillContainer = document.querySelector(".quick-filter-main")
    if (pillContainer) pillContainer.scrollLeft = 0
    rebindPriceRangeInputs()
    fixPriceRangeDataMax()
    setupDrawerClearButton()
    // Bind user selection flags for both drawer and dropdown sort radios
    document.querySelectorAll('input[name="sort_by"]').forEach((radio) => {
      // Only set userSelectedSort = true when user actively changes the sort (not on page load)
      radio.addEventListener("change", () => {
        userSelectedSort = true
      })
      radio.addEventListener("click", () => {
        userManuallySorted = true
      })
    })
    setTimeout(() => {
      renderQuick(getFilters())
      window.justClickedQuickFilter = false
      window.justClickedQuickFilterTimestamp = null
    }, 50)
    // Always update the selected sort custom label at the end of syncAll
    updateSelectedSortCustomLabel()

    // --- Forcefully trigger the change event if the radio is not checked after AJAX ---
    // (Handled by FINAL block above; removed duplicate logic)
  }

  // Shows or hides the mobile clear filters button based on active pills
  function toggleMobileClearButton() {
    const clearBtn = document.querySelector(".clear-filters-mobile-only")
    const anyActive = document.querySelectorAll(".quick-filter-pill").length > 0
    if (clearBtn) clearBtn.style.display = anyActive ? "flex" : "none"
  }

  // Renders all quick filter pills based on current filters and pill order; updates UI and scrolls as needed
  function renderQuick(filters) {
    filters = filters || {}
    // --- PATCH: Reset pills when no filters are active ---
    if (!filters || Object.keys(filters).length === 0) {
      setPillOrderArr([])
    }
    if (!mostPopularOptionsFromResponse?.length) {
      mostPopularOptionsFromResponse = extractLiveMostPopularOptionsFromDOM()
    }
    // Prevent flicker/blink when clicking on quick filter: If a quick filter was just clicked, skip full pill rebuild for this event.
    // Strong pill-flicker prevention: skip rendering for 200ms after quick filter click
    if (window.justClickedQuickFilter) {
      if (!window.justClickedQuickFilterTimestamp) {
        window.justClickedQuickFilterTimestamp = Date.now()
      }
      // If within 200ms of click, skip rendering
      if (Date.now() - window.justClickedQuickFilterTimestamp < 200) {
        return
      } else {
        window.justClickedQuickFilter = false
        window.justClickedQuickFilterTimestamp = null
      }
    }

    quickContainer.innerHTML = ""

    // --- PATCH: Order logic for pills ---
    // 1. Start from pillOrderArr from localStorage
    let pillOrderArr = getPillOrderArr()

    // Only keep pills that are still present in the current filters
    pillOrderArr = pillOrderArr.filter(([key, value]) => {
      if (key === "sort_by") return filters["sort_by"]?.[0] === value
      if (key === "price") {
        const min = filters["filter.v.price.gte"]?.[0] || ""
        const max = filters["filter.v.price.lte"]?.[0] || ""
        return value === `${min}_${max}` && (min || max)
      }
      return filters[key]?.includes(value)
    })

    // For any filter or sort in filters that is missing in pillOrderArr, append at the end to preserve order
    Object.entries(filters).forEach(([key, values]) => {
      if (key.startsWith("filter.v.price")) return
      if (key === "q" || key === "options[prefix]") return
      values.forEach((value) => {
        // Only allow sort_by=manual if it's explicitly in the URL!
        if (key === "sort_by" && value === "manual") {
          const params = new URLSearchParams(window.location.search)
          if (!(params.has("sort_by") && params.get("sort_by") === "manual"))
            return
        }
        const exists = pillOrderArr.some(([k, v]) => k === key && v === value)
        if (!exists) {
          pillOrderArr.unshift([key, value])
        }
      })
    })

    // Defensive: If sort_by=manual is not in the URL, remove it from pillOrderArr!
    const params = new URLSearchParams(window.location.search)
    pillOrderArr = pillOrderArr.filter(([key, value]) => {
      if (key === "sort_by" && value === "relevance") {
        return params.has("sort_by") && params.get("sort_by") === "relevance"
      }
      return true
    })

    // === PATCH: Do NOT re-order, move, or treat sort_by as special after this point. Render strictly in pillOrderArr order. ===

    // setPillOrderArr(pillOrderArr);

    // 5. Render: newest at left, strictly in pillOrderArr order (no sort_by reordering)
    pillOrderArr.forEach(([key, value]) => {
      // 👉 Skip "sort_by=manual" (never render a pill for Featured/default)
      if (key === "sort_by" && value === "relevance") {
        const params = new URLSearchParams(window.location.search)
        // Only render "Featured" pill if sort_by=manual is *explicitly* in the URL (user chose it)
        if (!(params.has("sort_by") && params.get("sort_by") === "relevance"))
          return
      }
      // Insert deduplication/visibility logic for Most Popular before pill creation
      // 👉 SKIP search and prefix params for pills!
      if (key === "q" || key === "options[prefix]") return
      if (key === "filter.p.m.custom.most_popular") {
        // Compare filter param values, not just label/text, for language-agnostic deduplication
        const quickBtn = Array.from(
          document.querySelectorAll(".quick-filter-main .custom-button a"),
        ).find((a) => {
          const btnUrl = new URL(a.href, location.origin)
          const btnVal = btnUrl.searchParams.get(
            "filter.p.m.custom.most_popular",
          )
          return (
            btnVal && btnVal.trim().toLowerCase() === value.trim().toLowerCase()
          )
        })
        if (quickBtn && quickBtn.classList.contains("selected")) {
          return
        }
        // Only show pill if option is checked in drawer
        const drawerCheckbox = Array.from(
          document.querySelectorAll(
            'input[name="filter.p.m.custom.most_popular"]',
          ),
        ).find(
          (input) =>
            decodeURIComponent(input.value).trim().toLowerCase() ===
            value.trim().toLowerCase(),
        )
        if (!drawerCheckbox || !drawerCheckbox.checked) return
      }
      let pill, label
      if (key === "sort_by") {
        // Human label for sort
        let sortLabel = value
        const sortRadio = document.querySelector(
          'input[name="sort_by"]:checked',
        )
        if (sortRadio) {
          let labelElem =
            document.querySelector(`label[for="${sortRadio.id}"]`) ||
            sortRadio.closest("label") ||
            sortRadio.parentElement
          if (labelElem) sortLabel = labelElem.textContent.trim()
        } else {
          const sortSelect = document.querySelector('select[name="sort_by"]')
          if (sortSelect) {
            const selected = sortSelect.querySelector("option:checked")
            if (selected) sortLabel = selected.textContent.trim()
          }
        }
        const fallbackSortLabels = {
          "best-selling": "Best Selling",
          "title-ascending": "Alphabetically, A–Z",
          "title-descending": "Alphabetically, Z–A",
          "price-ascending": "Price, Low to High",
          "price-descending": "Price, High to Low",
          "created-descending": "Date, new to old",
          "created-ascending": "Date, old to new",
          manual: "Featured",
        }
        if (!sortLabel || sortLabel === value) {
          sortLabel = fallbackSortLabels[value.toLowerCase()] || value
        }
        pill = document.createElement("span")
        pill.className = "quick-filter-pill"
        pill.textContent = sortLabel
        pill.setAttribute("data-sort-by", value.toLowerCase())
      } else if (key === "price") {
        const [min, max] = value.split("_")
        label = `Price: ${min ? currency + min : ""}${min && max ? " - " : ""}${max ? currency + max : ""}`
        pill = document.createElement("span")
        pill.className = "quick-filter-pill"
        pill.textContent = label
        pill.setAttribute("data-price", "1")
      } else if (key === "filter.p.m.custom.most_popular") {
        pill = document.createElement("span")
        pill.className = "quick-filter-pill"
        pill.textContent = value
        pill.dataset.p = `filter.p.m.custom.most_popular|${value}`
      } else {
        pill = document.createElement("span")
        pill.className = "quick-filter-pill"
        pill.textContent = value
        pill.dataset.p = key + "|" + value
      }
      quickContainer.appendChild(pill)
    })

    // Show quick filter container only if there are pills
    if (quickContainer.children.length > 0) {
      quickContainer.style.display = "flex"
    } else {
      quickContainer.style.display = "none"
    }

    // Ensure the first pill is visible (for mobile, resizing, etc.)
    if (window.quickFilterJustAdded) {
      if (window.skipScrollBecauseOfQuickFilterClick) {
        window.skipScrollBecauseOfQuickFilterClick = false
        return
      }
      if (!window.quickFilterClickPreventScroll) {
        tryScrollLeft()
      }
      window.quickFilterJustAdded = false
    }

    // Always reset the quick filter click flag after rendering completes (not a pill click)
    window.quickFilterClickPreventScroll = false

    // Show/hide Clear All button
    const isRealFilterActive = Object.keys(filters).some((key) => {
      if (key === "sort_by") return false
      const val = filters[key]
      return Array.isArray(val) && val.length > 0
    })
    clearAllBtn.style.display = isRealFilterActive ? "inline-block" : "none"

    // Update custom buttons
    document
      .querySelectorAll(".quick-filter-main .custom-button a")
      .forEach((a) => {
        const params = new URL(a.href).searchParams
        const [key, value] = params.entries().next().value || []
        a.classList.toggle("selected", !!filters[key]?.includes(value))
      })

    // Hide/show quick filter buttons based on active values
    const normalize = (str) =>
      str
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
    document
      .querySelectorAll(".quick-filter-main .custom-button a")
      .forEach((btn) => {
        const url = new URL(btn.href)
        const params = url.searchParams
        const filterKey = [...params.keys()].find((k) =>
          k.includes("filter.p.m.custom.most_popular"),
        )
        if (!filterKey) return
        const val = params.get(filterKey)
        const shouldShow = mostPopularOptionsFromResponse.some(
          (opt) => normalize(opt) === normalize(val),
        )
        btn.closest(".custom-button").style.display = shouldShow
          ? "inline-block"
          : "none"
      })

    // Attach mobile clear handler after rendering quick filters
    if (typeof attachMobileClearHandler === "function")
      attachMobileClearHandler()

    // Always reset the quick filter click flag after rendering completes
    window.justClickedQuickFilter = false
    window.justClickedQuickFilterTimestamp = null

    updateActiveSortLabel()
    toggleClearFiltersVisibility()
  }

  // Applies price filters from drawer inputs and triggers filter update
  function applyPriceFilters() {
    if (!drawerForm) return

    const minInput = drawerForm.querySelector(
      'input[name="filter.v.price.gte"]',
    )
    const maxInput = drawerForm.querySelector(
      'input[name="filter.v.price.lte"]',
    )
    const min = minInput?.value.trim()
    const max = maxInput?.value.trim()

    const filters = getFilters()

    // Add only if numeric and not empty
    if (min && !isNaN(min)) {
      filters["filter.v.price.gte"] = [min]
    } else {
      delete filters["filter.v.price.gte"]
    }

    if (max && !isNaN(max)) {
      filters["filter.v.price.lte"] = [max]
    } else {
      delete filters["filter.v.price.lte"]
    }

    // Optional validation
    if (min && max && parseFloat(min) > parseFloat(max)) {
      alert("Minimum price cannot be greater than maximum price")
      return
    }

    // --- PATCH: Move the price filter to leftmost in pill order if price is set ---
    if (min || max) {
      let pillOrderArr = getPillOrderArr()
      pillOrderArr = pillOrderArr.filter(([k, v]) => !(k === "price"))
      pillOrderArr.unshift(["price", `${min || ""}_${max || ""}`])
      setPillOrderArr(pillOrderArr)
    }

    shouldRestoreScroll = false
    updateURL(filters)
  }

  // Event handlers
  if (drawerForm) {
    drawerForm.addEventListener("change", (e) => {
      if (
        !e.target.name.startsWith("filter.v.price") &&
        e.target.type === "checkbox"
      ) {
        shouldRestoreScroll = false
        updateURL(getFilters())
      }
    })
  }

  quickContainer.addEventListener("click", (e) => {
    wasQuickFilterPillClick = true
    // Store the event globally for scroll logic
    window.quickFilterLastEvent = e
    const pill = e.target.closest(".quick-filter-pill")
    if (!pill) return

    // Set robust global flag for quick filter pill click
    window.justClickedQuickFilter = true
    // Set scroll-prevent flag for quick filter pill click (legacy)
    window.quickFilterClickPreventScroll = true
    // Set new global skipScrollBecauseOfQuickFilterClick flag
    window.skipScrollBecauseOfQuickFilterClick = true
    setTimeout(() => {
      window.skipScrollBecauseOfQuickFilterClick = false
    }, 1000)

    const keyValue = pill.dataset.p
    let key, value
    if (keyValue) {
      ;[key, value] = keyValue.split("|")
    } else {
      key = pill.dataset.key
      value = pill.dataset.value
    }

    // --- Uncheck matching drawer input (checkbox/radio) before updating URL/content ---
    // New logic: Use data-p attribute if present, fallback to data-sort-by/data-price logic.
    if (pill.hasAttribute("data-p")) {
      const pillType = pill.getAttribute("data-p").split("|")[0]
      const pillValue = pill.getAttribute("data-p").split("|")[1]
      const drawerInputSelector = `[name="${pillType}"][value="${pillValue}"]`
      const drawerInput = document.querySelector(drawerInputSelector)
      if (drawerInput && drawerInput.checked) {
        drawerInput.click() // Simulate a click to uncheck and trigger change events
      }
    } else if (drawerForm) {
      // Fallback to old logic for legacy pills
      const checkbox = drawerForm.querySelector(
        `input[name="${key}"][value="${value}"]`,
      )
      if (checkbox) {
        checkbox.checked = false
        checkbox.dispatchEvent(new Event("change", { bubbles: true }))
      }
    }

    const filters = getFilters()

    // --- Remove the pill from order array when clicked (it's being removed) ---
    let pillOrderArr = getPillOrderArr()
    pillOrderArr = pillOrderArr.filter(([k, v]) => !(k === key && v === value))
    setPillOrderArr(pillOrderArr)

    // Only scroll pills to left on mobile after user click
    if (window.innerWidth <= 767) {
      const pillContainer = document.querySelector(".quick-filter-main")
      if (pillContainer && pillContainer.scrollLeft > 0) {
        pillContainer.scrollTo({ left: 0, behavior: "smooth" })
        setTimeout(() => {
          window.scrollBy(0, 0)
        }, 1)
      }
    }

    if (pill.hasAttribute("data-sort-by")) {
      delete filters["sort_by"]
      shouldRestoreScroll = false
      updateURL(filters)
      // Reset scroll-prevent flag after navigation
      setTimeout(() => {
        window.quickFilterClickPreventScroll = false
        window.justClickedQuickFilter = false
        window.skipScrollBecauseOfQuickFilterClick = false
      }, 1000)
      return
    }

    if (pill.hasAttribute("data-price")) {
      delete filters["filter.v.price.gte"]
      delete filters["filter.v.price.lte"]
      if (drawerForm) {
        drawerForm
          .querySelectorAll('input[name^="filter.v.price"]')
          .forEach((i) => (i.value = ""))
      }
    } else {
      if (filters[key]) {
        filters[key] = filters[key].filter((v) => v !== value)
        if (!filters[key].length) delete filters[key]
      }
    }
    shouldRestoreScroll = false
    loadContent(filters)

    wasQuickFilterPillClick = true
    // Reset scroll-prevent flag after navigation
    setTimeout(() => {
      window.quickFilterClickPreventScroll = false
      window.justClickedQuickFilter = false
      window.skipScrollBecauseOfQuickFilterClick = false
    }, 1000)
    toggleMobileClearButton()
  })

  clearAllBtn.removeEventListener("click", resetAllFiltersAndReload)
  clearAllBtn.addEventListener("click", function (e) {
    e.preventDefault()
    resetAllFiltersAndReload()
  })

  // --- Add logic for .quick-filter-clear-all and .quick-filter-clear-all-mobile buttons ---
  document.querySelectorAll(".quick-filter-clear-all").forEach((button) => {
    button.removeEventListener("click", resetAllFiltersAndReload)
    button.addEventListener("click", function (e) {
      e.preventDefault()
      resetAllFiltersAndReload()
    })
  })

  document
    .querySelectorAll(".quick-filter-main .custom-button a")
    .forEach((a) => {
      // Set the flag on both click and mousedown for best results
      a.addEventListener("mousedown", () => {
        window.justClickedQuickFilter = true
        window.justClickedQuickFilterTimestamp = Date.now()
      })
      a.addEventListener("click", async (e) => {
        e.preventDefault()
        // Store the event globally for scroll logic
        window.quickFilterLastEvent = e
        window.skipScrollOnQuickFilter = true
        const params = new URL(a.href).searchParams
        const [key, value] = params.entries().next().value || []

        const filters = getFilters()
        filters[key] = filters[key] || []

        let activated = false
        if (filters[key].includes(value)) {
          filters[key] = filters[key].filter((v) => v !== value)
        } else {
          filters[key].push(value)
          activated = true
        }

        if (!filters[key].length) delete filters[key]

        // --- PATCH: Only move pill to leftmost if filter is being activated (checked/added) ---
        if (activated) {
          let pillOrderArr = getPillOrderArr()
          pillOrderArr = pillOrderArr.filter(
            ([k, v]) => !(k === key && v === value),
          )
          // Only unshift sort_by=manual if it is present in the URL
          if (key === "sort_by" && value === "manual") {
            const params = new URLSearchParams(window.location.search)
            if (
              !(params.has("sort_by") && params.get("sort_by") === "manual")
            ) {
              setPillOrderArr(pillOrderArr)
              return
            }
          }
          pillOrderArr.unshift([key, value])
          setPillOrderArr(pillOrderArr)
        }

        // Only scroll pills to left on mobile after user click
        if (window.innerWidth <= 767) {
          const pillContainer = document.querySelector(".quick-filter-main")
          if (pillContainer && pillContainer.scrollLeft > 0) {
            pillContainer.scrollTo({ left: 0, behavior: "smooth" })
            setTimeout(() => {
              window.scrollBy(0, 0)
            }, 1)
          }
        }

        if (drawerForm) {
          const checkbox = drawerForm.querySelector(
            `input[name="${key}"][value="${value}"]`,
          )
          if (checkbox) checkbox.checked = !!filters[key]?.includes(value)
        }

        // 🔄 Update and reload
        window.quickFilterJustAdded = true
        shouldRestoreScroll = false
        await updateURL(filters)
      })
    })

  // Initialize
  setupPriceFilters()
  syncAll()
  // Force quick filters container to left on first load (use unique variable to avoid conflict)
  const pillContainerInitial = document.querySelector(".quick-filter-main")
  if (pillContainerInitial) {
    pillContainerInitial.scrollLeft = 0
  }
  // Run clear filters visibility logic once on load
  toggleClearFiltersVisibility()
  // Insert quick filters container positioning
  insertQuickFiltersContainer()
  // Inject clear filters button for mobile
  injectClearFiltersButtonMobile()
  // Enable mobile clear filters binding
  bindMobileClearFilters()
  // Enable pill container drag scrolling
  const pillContainer = document.querySelector(".quick-filter-main")
  if (pillContainer) {
    let isDown = false
    let startX
    let scrollLeft
    pillContainer.addEventListener("mousedown", (e) => {
      isDown = true
      pillContainer.classList.add("dragging")
      startX = e.pageX - pillContainer.offsetLeft
      scrollLeft = pillContainer.scrollLeft
    })
    pillContainer.addEventListener("mouseleave", () => {
      isDown = false
      pillContainer.classList.remove("dragging")
    })
    pillContainer.addEventListener("mouseup", () => {
      isDown = false
      pillContainer.classList.remove("dragging")
    })
    pillContainer.addEventListener("mousemove", (e) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - pillContainer.offsetLeft
      const walk = (x - startX) * 1.5
      pillContainer.scrollLeft = scrollLeft - walk
    })
  }
  // window.addEventListener("resize", () => {
  //   const pillContainer = document.querySelector(".quick-filter-main")
  //   const firstPill = pillContainer?.querySelector(".quick-filter-pill")
  //   if (pillContainer && firstPill) {
  //     firstPill.scrollIntoView({
  //       behavior: "auto",
  //       block: "nearest",
  //       inline: "start",
  //     })
  //   }
  // })
  updateActiveSortLabel()
  toggleClearFiltersVisibility()
})
// ============================================================================
// Clear All, Mobile/Drawer, Utility
// ============================================================================
// Injects a clear filters button for mobile view above the filter drawer
function injectClearFiltersButtonMobile() {
  if (document.querySelector(".quick-filter-clear-all-mobile.in-header")) return

  const clearFilters =
    document.querySelector(".active-facets__button-remove").textContent ||
    "Clear Filters"
  const clearBtn = document.createElement("button")
  clearBtn.className =
    "quick-filter-clear-all quick-filter-clear-all-mobile in-header button button--tertiary"
  clearBtn.innerText = clearFilters
  clearBtn.style.display = "none"

  clearBtn.removeEventListener("click", resetAllFiltersAndReload)
  clearBtn.addEventListener("click", function (e) {
    e.preventDefault()
    resetAllFiltersAndReload()
  })

  const mobileDrawer = document.querySelector(
    "menu-drawer.mobile-facets__wrapper",
  )
  if (mobileDrawer && mobileDrawer.parentNode) {
    mobileDrawer.parentNode.insertBefore(clearBtn, mobileDrawer)
  }
}

// Overrides price input behavior to trigger AJAX updates on blur/Enter/input
function overridePriceInputsBehavior(form) {
  if (!form) return
  const minInput = form.querySelector('input[name="filter.v.price.gte"]')
  const maxInput = form.querySelector('input[name="filter.v.price.lte"]')
  const commitPrice = () => {
    const filters = getFilters()
    shouldRestoreScroll = false
    updateURL(filters)
  }
  if (minInput && !minInput.classList.contains("price-bound")) {
    minInput.addEventListener("input", (e) => e.stopPropagation())
    minInput.addEventListener("blur", commitPrice)
    minInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault()
        commitPrice()
      }
    })
    minInput.classList.add("price-bound")
  }
  if (maxInput && !maxInput.classList.contains("price-bound")) {
    maxInput.addEventListener("input", (e) => e.stopPropagation())
    maxInput.addEventListener("blur", commitPrice)
    maxInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault()
        commitPrice()
      }
    })
    maxInput.classList.add("price-bound")
  }
}

// Shows/hides clear filter buttons based on whether any filters are active (desktop & mobile)
function toggleClearFiltersVisibility() {
  const urlParams = new URLSearchParams(window.location.search)
  const hasAnyFilter = [...urlParams.keys()].some(
    (key) => key.startsWith("filter.") || key === "sort_by",
  )

  const desktopClear = document.querySelector(".quick-filter-clear-all-desktop")
  const mobileClear = document.querySelector(
    ".quick-filter-clear-all-mobile.in-header",
  )
  const quickClear = document.querySelector(
    ".quick-filter-clear-all:not(.in-header)",
  )

  // Always show desktop clear filter if any filter is active, on all screen sizes
  if (desktopClear) {
    desktopClear.style.display = hasAnyFilter ? "inline-block" : "none"
  }

  if (mobileClear) {
    // You can keep hiding mobile clear filter on desktop if needed, or always show
    mobileClear.style.display = "none"
  }

  if (quickClear) {
    // Keep original logic for other clear buttons if needed
    quickClear.style.display = hasAnyFilter ? "inline-block" : "none"
  }
}

document.addEventListener("filters:updated", toggleClearFiltersVisibility)
window.addEventListener("resize", toggleClearFiltersVisibility)
window.addEventListener("popstate", toggleClearFiltersVisibility)

const clearFilterObserver = new MutationObserver(() => {
  toggleClearFiltersVisibility()
})
clearFilterObserver.observe(document.body, {
  childList: true,
  subtree: true,
})

// Binds mobile clear filters button to reset filters, update URL, and re-render pills, preserving q and options[prefix]
function bindMobileClearFilters() {
  document.querySelectorAll(".quick-filter-clear-all-mobile").forEach((btn) => {
    btn.removeEventListener("click", resetAllFiltersAndReload)
    btn.addEventListener("click", function (e) {
      e.preventDefault()
      resetAllFiltersAndReload()
    })
  })
}

document.addEventListener("filters:updated", toggleClearFiltersVisibility)
document
  .querySelectorAll(".mobile-facets__footer .button--primary")
  .forEach((btn) => {
    btn.addEventListener("click", () => {
      setTimeout(toggleClearFiltersVisibility, 300)
    })
  })

// Ensures the quick filters container is correctly inserted in the DOM after custom blocks
function insertQuickFiltersContainer() {
  const container = document.querySelector(".quick-filter-main")
  const target = container?.querySelector(".multiple-custom-block")
  const pillsWrapper = document.querySelector(".quick-filters-container")

  if (pillsWrapper && target && container.contains(target)) {
    container.insertBefore(pillsWrapper, target)
  } else if (pillsWrapper && container) {
    container.appendChild(pillsWrapper)
  }
}

// ============================================================================
// Show More Button Logic
// ============================================================================
// Handles AJAX loading and appending of more products when the "Show More" button is clicked
function handleShowMoreClick(e) {
  e.preventDefault()
  const button = e.currentTarget

  let page = parseInt(button.dataset.page || "2")
  if (!page || isNaN(page)) page = 2

  const baseUrl =
    button.dataset.baseUrl || window.location.pathname.split("?")[0]
  const query = new URLSearchParams(window.location.search)
  query.set("page", page)
  const url = `${baseUrl}?${query.toString()}`

  const grid =
    document.querySelector("#product-grid") ||
    document.querySelector("#ProductGridContainer")
  const countElem = document.querySelector(".custom-show-product")
  const totalElem = document.querySelector(".custom-total-product")
  const progress = document.querySelector(".load-more-progress-bar")
  const spinner = document.querySelector(".load-more-spinner")

  if (countElem && grid) {
    const visibleProducts = grid.querySelectorAll(".grid__item")
    countElem.textContent = visibleProducts.length.toString()
  }

  const totalCount = parseInt(totalElem?.textContent || "0")

  button.classList.add("hidden")
  button.dataset.page = (page + 1).toString()
  spinner?.classList.remove("hidden")

  fetch(url)
    .then((res) => res.text())
    .then((html) => {
      const wrapper = document.createElement("div")
      wrapper.innerHTML = html

      const gridWrapper =
        wrapper.querySelector("#product-grid") ||
        wrapper.querySelector("#ProductGridContainer")
      const newItems = gridWrapper
        ? gridWrapper.querySelectorAll(".grid__item")
        : []
      // --- Use display count instead of DOM count
      const existingCount = parseInt(countElem?.textContent || "0")
      let appendCount = 0
      newItems.forEach((item) => {
        grid.appendChild(item)
        appendCount++
      })
      if (typeof theme_custom?.percussiveMassageSlider === "function") {
        theme_custom.percussiveMassageSlider()
      }
      // --- After appending, update count based on previous count + new items
      const updatedCount = existingCount + appendCount
      const newTotalElem = wrapper.querySelector(".custom-total-product")
      if (newTotalElem && totalElem)
        totalElem.textContent = newTotalElem.textContent
      if (progress && totalElem) {
        const totalValue = parseInt(totalElem.textContent || "0")
        progress.style.width = `${(updatedCount / totalValue) * 100}%`
      }

      const newLoadMore = wrapper.querySelector(".load-more-part")
      const curLoadMore = document.querySelector(".load-more-part")
      if (newLoadMore && curLoadMore) {
        curLoadMore.replaceWith(newLoadMore.cloneNode(true))
        // Now update the count after DOM replacement so it isn't overwritten
        const newCountElem = document.querySelector(".custom-show-product")
        const newTotalElemAfterReplace = document.querySelector(
          ".custom-total-product",
        )
        if (newCountElem) newCountElem.textContent = updatedCount.toString()
        if (newTotalElemAfterReplace && newTotalElem) {
          newTotalElemAfterReplace.textContent = newTotalElem.textContent
        }
        // Move rebindShowMoreButton call AFTER product cards are appended and inserted into the DOM
        setTimeout(function () {
          if (typeof rebindShowMoreButton === "function") {
            rebindShowMoreButton()
          }
        }, 0)

        // Update next button page from current grid count
        const newButton = document.querySelector(".load-more-btn")
        if (newButton) {
          const itemsPerPage = parseInt(
            document.querySelector(".custom-show-product")?.dataset.perPage ||
              "36",
          )
          const nextPage = Math.ceil(updatedCount / itemsPerPage) + 1
          newButton.dataset.page = nextPage.toString()
        }
      }
    })
    .catch(() => {})
    .finally(() => {
      spinner?.classList.add("hidden")
    })
}

// Rebinds the Show More button click handler after DOM replacement
function rebindShowMoreButton() {
  const showMoreBtn = document.querySelector(".load-more-btn")
  if (showMoreBtn) {
    showMoreBtn.removeEventListener("click", handleShowMoreClick)
    showMoreBtn.addEventListener("click", handleShowMoreClick)
  }
}
window.rebindShowMoreButton = rebindShowMoreButton

// ============================================================================
// Miscellaneous/Global Event Handlers
// ============================================================================
document.addEventListener("click", function (e) {
  const clearBtn = e.target.closest(".js-drawer-clear")
  if (clearBtn) {
    e.preventDefault()
    const clearURL = clearBtn.getAttribute("href")
    history.pushState({}, "", clearURL)
    if (
      typeof FacetFiltersForm !== "undefined" &&
      typeof FacetFiltersForm.resetAllFilters === "function"
    ) {
      FacetFiltersForm.resetAllFilters()
    }
    if (typeof loadContent === "function") {
      shouldRestoreScroll = false
      loadContent(clearURL)
    }
  }
})

// Binds the mobile drawer clear button to reset all filters and reload content
function attachMobileClearHandler() {
  document.querySelectorAll(".mobile-facets__clear").forEach((btn) => {
    btn.removeEventListener("click", resetAllFiltersAndReload)
    btn.addEventListener("click", function (e) {
      e.preventDefault()
      resetAllFiltersAndReload()
    })
  })
}

attachMobileClearHandler()

document.addEventListener("click", function (e) {
  const isMedia = e.target.closest(".card__media img")
  const isContent = e.target.closest(".card__content.card__content--top")
  const card = e.target.closest(".card[data-prod-url]")
  if (
    (isMedia || isContent) &&
    card &&
    !e.target.closest("a") &&
    !e.target.closest("button")
  ) {
    const url = card.getAttribute("data-prod-url")
    if (url) {
      window.location.href = url
    }
  }
})

function runInitialTitleSortWhenReady() {
  const urlParams = new URLSearchParams(window.location.search)
  const sortBy = urlParams.get("sort_by")
  if (sortBy !== "title-ascending" && sortBy !== "title-descending") return

  function trySort() {
    const curGrid = document.querySelector("#ProductGridContainer")
    const grid = curGrid && curGrid.querySelector("ul.product-grid")
    const drawer =
      document.querySelector("#FacetFiltersForm") ||
      document.querySelector("#FacetFiltersFormMobile")
    if (curGrid && grid && drawer) {
      const items = Array.from(grid.children).filter((li) =>
        li.classList.contains("grid__item"),
      )
      items.sort((a, b) => {
        const aTitle = (
          a.querySelector(
            ".card__heading, .product-title, .card__information a, .full-unstyled-link",
          )?.textContent || ""
        )
          .trim()
          .toLowerCase()
        const bTitle = (
          b.querySelector(
            ".card__heading, .product-title, .card__information a, .full-unstyled-link",
          )?.textContent || ""
        )
          .trim()
          .toLowerCase()
        if (aTitle < bTitle) return sortBy === "title-ascending" ? -1 : 1
        if (aTitle > bTitle) return sortBy === "title-ascending" ? 1 : -1
        return 0
      })
      items.forEach((item) => grid.appendChild(item))
      console.log("[DEBUG] [INITIAL] Sorting complete after DOM ready.")
      return true
    }
    return false
  }

  // Try immediately, then poll every 100ms up to 2s
  if (!trySort()) {
    let tries = 0
    const maxTries = 20
    const interval = setInterval(() => {
      if (trySort() || ++tries >= maxTries) clearInterval(interval)
    }, 100)
  }
}

document.addEventListener("DOMContentLoaded", runInitialTitleSortWhenReady)
